import React from 'react';

const GroupImage = ({image}) => 
    <div className="group__image">
        <img src={image}/>
    </div>

export default GroupImage;
